import React from 'react';

interface VendorAvatarProps {
  name: string;
  avatarUrl?: string | null;
  size?: number;
}

/** Vendor storefront avatar — shows the uploaded image when present, else a
 *  colored circle with the vendor's initial. */
export const VendorAvatar: React.FC<VendorAvatarProps> = ({
  name,
  avatarUrl,
  size = 32,
}) => {
  const initial = (name?.trim()?.[0] ?? '?').toUpperCase();
  const common: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    flexShrink: 0,
    objectFit: 'cover',
  };
  if (avatarUrl) {
    return <img src={avatarUrl} alt={name} style={common} />;
  }
  return (
    <span
      style={{
        ...common,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--blue-600)',
        color: 'white',
        fontSize: size * 0.42,
        fontWeight: 700,
      }}
    >
      {initial}
    </span>
  );
};
